<div class="title-container">
  <h2 class="title"> {{ 'Reports.ClosedCases.Title' | translate }} </h2>
  <hr class="separation-line" />
</div>
<section class="filters-container">
  <fieldset class="customers">
    <label class="label"> {{'Reports.Filters.CustomerNumbers' | translate}} </label>
    <custom-multi-select [options]="customers$ | async" [clearEnabled]="true" [searchEnabled]="true"
      [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true"
      [disabled]="userAssignedCustomersCount <= 1" (selectedKeysChange)="onSelectedCustomersChange($event)">
    </custom-multi-select>
  </fieldset>

  <fieldset>
    <label class="label"> {{'Reports.Filters.StartDate' | translate}} </label>
    <p-datepicker [(ngModel)]="startDate" [dateFormat]="dateFormat"></p-datepicker>
  </fieldset>

  <fieldset>
    <label class="label"> {{'Reports.Filters.EndDate' | translate}} </label>
    <p-datepicker [(ngModel)]="endDate" [dateFormat]="dateFormat"></p-datepicker>
  </fieldset>

  <label class="custom-checkbox-container">
    <input type="checkbox" class="column-checkbox" [(ngModel)]="includeReminderCases" name="includeReminderCases"
      id="includeReminderCases">
    <span class="checkmark"></span>
    <label for="includeReminderCases">{{'Reports.ClosedCases.IncludeReminderCases' | translate}}</label>
  </label>
</section>
<div class="buttons">
  <button class="button-basic" [disabled]="isLoading" (click)="onGenerateReport()">{{'Reports.Buttons.GenerateReport' | translate}}</button>
  <button class="button-basic-reverse" [disabled]="isLoading" (click)="onExportExcelClick()">{{'Reports.Buttons.Download' | translate}}</button>
</div>  
<section>
  <label class="totals-label" *ngIf="this.totalCases">{{this.totalCases}}</label>
</section>
<section class="results-container" *ngIf="closedCases">
  <p-table #closedCasesTable size="small" [paginator]="true" [columns]="cols" [lazy]="true"
    (onLazyLoad)="onPageChange($event)" [(rows)]="numberOfRowsPerPage" [rowsPerPageOptions]="[5,10,15,20]"
    [totalRecords]="totalNumberOfItems" selectionMode="single" [loading]="isLoading" [value]="closedCases"
    [customSort]="true" sortField="debtorName" [sortOrder]="1">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [pSortableColumn]="col.name" *ngFor="let col of columns"> {{ col.translationTag | translate }}
          <p-sortIcon [field]="col.name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-case let-columns="columns">
      <tr (click)="openCaseInNewTab(case)" class="clickable">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'date'"> {{ case[col.name] | date: dateFormat }} </ng-container>
            <ng-container *ngSwitchCase="'decimal'"> {{ case[col.name] | number : numberFormat.style:
              numberFormat.culture }} </ng-container>
            <ng-container *ngSwitchDefault>{{case[col.name]}}</ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>